require('./paginate.scss');

var deps = [];

module.exports = angular
  .module('bench.ui.paginate', deps)

  .constant('blPaginateConfig', {
    maxSize: 9,
  })

  .directive('blPaginate', [
    '$parse',
    'blPaginateConfig',
    function ($parse, blPaginateConfig) {
      return {
        restrict: 'EA',
        scope: {
          totalItems: '=',
        },
        require: ['blPaginate', '?ngModel'],
        controller: require('./paginateCtrl'),
        template: require('./paginate.html'),
        link: function (scope, element, attrs, ctrls) {
          var paginationCtrl = ctrls[0],
            ngModelCtrl = ctrls[1];

          if (!ngModelCtrl) {
            return; // do nothing if no ng-model
          }

          // Setup configuration parameters
          var maxSize = angular.isDefined(attrs.maxSize)
            ? scope.$parent.$eval(attrs.maxSize)
            : blPaginateConfig.maxSize;

          paginationCtrl.init(ngModelCtrl, blPaginateConfig);

          if (attrs.maxSize) {
            scope.$parent.$watch($parse(attrs.maxSize), function (value) {
              maxSize = parseInt(value, 10);
              paginationCtrl.render();
            });
          }

          // Create page object used in template
          function makePage(number, text, isActive) {
            return {
              number: number,
              text: text,
              active: isActive,
            };
          }

          function getPages(currentPage, totalPages) {
            var pages = [];

            // Default page limits
            var startPage = 1,
              endPage = totalPages;
            var isLimited = maxSize < totalPages;

            // recompute if maxSize
            if (isLimited) {
              // Current page is displayed in the middle of the visible ones
              startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
              endPage = startPage + maxSize - 1;

              // Adjust if limit is exceeded
              if (endPage > totalPages) {
                endPage = totalPages;
                startPage = endPage - maxSize + 1;
              }

              // If it doesn't start with the first page, make room for it to be added later.
              if (startPage > 1) {
                startPage++;
              }

              // If it doesn't end with the last page, make room for it to be added later.
              if (endPage < totalPages) {
                endPage--;
              }
            }

            // Add page number links
            for (var number = startPage; number <= endPage; number++) {
              var page = makePage(number, number, number === currentPage);
              pages.push(page);
            }

            // Add links to move between page sets
            if (isLimited) {
              if (startPage > 1) {
                var previousPageSet = makePage(startPage - 1, '...', false);
                pages.unshift(previousPageSet);

                var firstPageSet = makePage(1, '1', false);
                pages.unshift(firstPageSet);
              }

              if (endPage < totalPages - 1) {
                var nextPageSet = makePage(endPage + 1, '...', false);
                pages.push(nextPageSet);
              }
              if (endPage < totalPages) {
                var lastPageSet = makePage(totalPages, totalPages, false);
                pages.push(lastPageSet);
              }
            }

            return pages;
          }

          var originalRender = paginationCtrl.render;
          paginationCtrl.render = function () {
            originalRender();
            if (scope.page > 0 && scope.page <= scope.totalPages) {
              scope.pages = getPages(scope.page, scope.totalPages);
            }
          };
        },
      };
    },
  ]);
